import React, { useEffect, useState } from 'react'
import PageTitle from '../../components/PageTitle'
import { teamService } from '../../services/teamService'

const Team = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchAsync();
  }, []);

  const fetchAsync = async () => {
    try {
      setError("");
      setLoading(true);
      const response = await teamService.getPublishedAsync();
      if (!response.isSuccess) {
        setError(response.errors?.[0] || "Unable to load the team right now. Please try again later.");
        setMembers([]);
        return;
      }
      setMembers(response.value || []);
    } catch (err) {
      setError("Unable to load the team right now. Please try again later.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle title="Meet Our Expert" />
      {/* Team area start here */}
      <section className="team-section pt-120 pb-120">
        <div
          className="team-shape wow slideInLeft d-none"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <img
            className="sway__animation"
            src="images/shape/team-shape.png"
            alt="Image"
          />
        </div>
        <div className="container">
          {loading && (
            <div className="row">
              <div className="col-12 text-center">
                <p>Loading team...</p>
              </div>
            </div>
          )}

          {!loading && error && (
            <div className="row">
              <div className="col-12 text-center">
                <p>{error}</p>
              </div>
            </div>
          )}

          {!loading && !error && members.length === 0 && (
            <div className="row">
              <div className="col-12 text-center">
                <p>Team information is currently unavailable.</p>
              </div>
            </div>
          )}

          {!loading && !error && members.length > 0 && (
            <div className="row g-4">
              {members.map((member, index) => (
                <div
                  key={member.id}
                  className="col-md-6 col-xl-3 wow fadeInUp"
                  data-wow-delay={`${(index % 4) * 200}ms`}
                  data-wow-duration="1500ms"
                >
                  <div className="team-block">
                    <div className="inner-box">
                      <figure className="image">
                        <img
                          src={member.imagePath}
                          alt="Image"
                          style={{ width: "100%", aspectRatio: "1 / 1", objectFit: "cover" }}
                        />
                      </figure>
                      <div className="socials d-none">
                        <i className="fa-solid fa-plus" />
                        <ul>
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-facebook-f" />
                            </a>
                          </li>
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-instagram" />
                            </a>
                          </li>
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-linkedin-in" />
                            </a>
                          </li>
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-behance" />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="content-box">
                        <h4 className="title">
                          <a href={member.imagePath} target="_blank" rel="noopener noreferrer">
                            {member.name}
                          </a>
                        </h4>
                        <p className="sub-title">{member.position}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
      {/* Team area end here */}
    </>
  );
}

export default Team
